module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "md": _vm.feld.breite,
      "cols": "12",
      "sm": "6"
    }
  }, [(_vm.feld.type === 'String') ? _c('span', [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Select') ? _c('span', [_c('v-select', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "items": _vm.feld.options
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Date') ? _c('span', [_c('v-menu', {
    ref: _vm.value,
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "hide-details": "auto",
            "dense": "",
            "outlined": "",
            "value": _vm.formatDate,
            "label": _vm.feld.label,
            "readonly": "",
            "clearable": ""
          },
          on: {
            "click:clear": function($event) {
              return _vm.clearValue()
            }
          }
        }, on))]
      }
    }], null, false, 1531838768),
    model: {
      value: (_vm.menuFeldVar),
      callback: function($$v) {
        _vm.menuFeldVar = $$v
      },
      expression: "menuFeldVar"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": _vm.sendDataBack,
      "input": function($event) {
        _vm.menuFeldVar = false
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Anrede') ? _c('span', [_c('v-select', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "items": _vm.itemsAnrede
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Briefanrede') ? _c('span', [_c('v-select', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "items": _vm.itemsBriefanrede
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Status') ? _c('span', [_c('v-select', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "items": _vm.itemsStatus
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Telefon') ? _c('span', [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "rules": [_vm.rules.telefonnummer],
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label
    },
    on: {
      "input": _vm.formatPhoneNumber,
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Leibvater') ? _c('span', [_c('v-autocomplete', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "clearable": "",
      "clear-icon": "close",
      "items": _vm.$selectLeibvater()
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Verbindung' || _vm.feld.type === 'Verbindungen') ? _c('span', [_c('v-combobox', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "multiple": _vm.feld.type === 'Verbindungen',
      "items": _vm.selectVerbindung,
      "label": _vm.feld.label,
      "clearable": ""
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Gruppen') ? _c('span', [_c('v-select', {
    attrs: {
      "hide-details": "auto",
      "multiple": "",
      "small-chips": "",
      "deletable-chips": "",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "items": _vm.itemsGruppen
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'Zirkel') ? _c('span', [_c('v-select', {
    attrs: {
      "clearable": "",
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "items": _vm.itemsZirkel
    },
    on: {
      "change": _vm.sendDataBack
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.feld.type === 'money') ? _c('span', [_c('v-text-field', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "label": _vm.feld.label,
      "rules": [_vm.rules.required, _vm.rules.geld]
    },
    on: {
      "change": _vm.sendDataBack,
      "input": _vm.formatMoney
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b830ecd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/kontaktfield.vue
// module id = 806
// module chunks = 15